type DepartmentFilter = {
    searchText: string;
};

export default DepartmentFilter;

export function defaultDepartmentFilter(): DepartmentFilter {
    return {
        searchText: ""
    };
}
